import React from 'react';
import Loader from 'react-loader-spinner';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import Router from '../Router';
import { lightTheme, darkTheme } from '../../theme';
import useUserPreferencesContext from '../../store/userPreferences/useUserPreferencesContext';
import useGapi from '../../hooks/useGapi';
import DivLoader from './App.styled';

export default () => {
  const gapi = useGapi();
  const { isLightTheme } = useUserPreferencesContext();
  const currentTheme = isLightTheme ? lightTheme : darkTheme;

  if (!gapi) {
    return (
      <DivLoader>
        <Loader type="Circles" width={50} height={50} color="#556cd6" visible />
      </DivLoader>
    );
  }
  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      <Router />
    </ThemeProvider>
  );
};
